export const separateCommas = (string) => {
  return string?.split(/[,+]/);
}